import c_15 from "../../assets/audio-screen/unit15/c_15.mp3"



export const audio15 = [
   {
    'text':'Michele: Hôm nay cậu có khỏe không Mark?\nMark: Tớ khoẻ cảm ơn cậu, kỳ nghỉ tới cậu sẽ đi đâu?\nMichele: Tớ sẽ đi đến Việt Nam để học tiếng Việt.\nMark: Tại sao, cậu muốn học tiếng Việt?\nMichele: Bởi vì tiếng Việt rất thú vị và tớ muốn khám phá văn hóa của người Việt Nam.\nMark: Cậu học tiếng Việt với mục đích gì nữa không?\nMichele: Tớ muốn nói chuyện nhiều với người Việt và tớ nghĩ tớ sẽ ở lại Việt Nam một thời gian lâu. Hơn nữa, tớ sẽ làm việc ở Việt Nam vào năm tới.\nMark: Thế cậu đã học tiếng Việt ở đâu được bao lâu rồi?\nMichele: Tớ đã học tiếng Việt ở trung tâm tiếng Việt ở Anh được ê thăng rơi. Chính vì vậy tớ muốn đến Việt Nam để được nói chuyện trực tiếp với người bản địa. Điều đó giúp tớ phát triển vốn ngôn ngữ Viết của mình.\nMark: Tớ hiểu rồi, tớ chúc cậu thành công nhé.\nMichele: Tớ cảm ơn cậu.\n',
    'audio': c_15,
  },

];

